import { useTranslations } from '@aikoa/i18n/react'
import { View } from 'react-native'
import { ManageUserContacts } from '~/components/contacts/ManageContacts'
import Icon from '~/components/Icon'
import ContentBox from '~/components/layout/ContentBox'
import ScreenView from '~/components/layout/ScreenView'
import { ButtonLabel, LinkButton } from '~/components/ui/button'

export default function ContactsPage() {
  const { t } = useTranslations('contacts')

  return (
    <ScreenView innerClassName="flex-1">
      <ContentBox
        scrollable={false}
        footer={
          <View className="absolute bottom-0 left-0 right-0 px-5 pb-4">
            <LinkButton href="/(authenticated)/contacts/add" variant="primary" size="default">
              <ButtonLabel icon={<Icon name="plus" size={14} />}>
                {t(($) => $.edit.addNew)}
              </ButtonLabel>
            </LinkButton>
          </View>
        }
        footerClassName="pb-0"
        contentContainerClassName="p-0">
        <ManageUserContacts />
      </ContentBox>
    </ScreenView>
  )
}
